const ONLY_WHITESPACE_RE =
  /^([\s\u00A0\u200B]|&nbsp;|&ZeroWidthSpace;|&#8203;|&#x200B;)*$/;

export const isOnlyWhitespace = (text: string | null | undefined): boolean => {
  if (!text) {
    return true;
  }

  return ONLY_WHITESPACE_RE.test(text);
};
